
import { mixins, Options } from 'vue-class-component';
import ShopifyClient from '@/api/shopify/shopify';
import { ShopifyCart } from '@/api/shopify/ShopifyCart';
import { TokenCartItem } from '@/api/shopify/types';
import CheckoutWidgetMixin from '@/mixins/checkoutWidget';
import { IToken } from '../../api/models/token';
import LazyImage from '../LazyImage.vue';

@Options({
  components: {
    LazyImage
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    camapignId: {
      type: Number,
      required: true
    },
    token: {
      type: Object,
      required: true
    },
    productId: {
      type: Number,
      required: true
    }
  }
})
export default class MTokenCartDelete extends mixins(CheckoutWidgetMixin) {
  readonly id: number;
  readonly campaignId: number;
  readonly token: IToken;
  readonly productId: number;

  shopifyClient = new ShopifyClient();

  product: {
    featured_image: string;
    formattedPrice: number;
    url: string;
    title: string;
  } | null = null;
  removingFromCart = false;

  async removeItemFromCart() {
    // Cannot invoke removeItemFromCart multiple times
    if (this.removingFromCart) return;

    if (this.state.storedShopifyCart && this.state.storedShopifyCart.pendingDraftOrder) {
      alert(
        `You have a pending checkout. Please complete the checkout or clear your cart to add more token gated items.`
      );
      this.removingFromCart = false;
      return;
    }

    const oauthToken = await this.getOAuth();
    const currentShop = await this.state.ShopifyAPIClient.getCurrentShop();

    try {
      const shopifyCart = new ShopifyCart(await this.state.ShopifyAPIClient.getBrowserCart());

      let tokenCart = this.state.storedShopifyCart;
      const existingTokenCartItems = tokenCart.items.filter((item: TokenCartItem) => {
        return (
          item.id === this.id &&
          item.campaignId === this.campaignId &&
          item.token.contractAddress === this.token.contractAddress &&
          item.token.tokenId === this.token.tokenId
        );
      });

      const remainingTokenCartItems = tokenCart.items.filter((item: TokenCartItem) => {
        return !(
          item.id === this.id &&
          item.campaignId === this.campaignId &&
          item.token.contractAddress === this.token.contractAddress &&
          item.token.tokenId === this.token.tokenId
        );
      });
      tokenCart = await this.state.RedeemAPIClient.createOrUpdateCart(oauthToken, currentShop, {
        ...this.state.storedShopifyCart,
        items: remainingTokenCartItems
      });
      this.$store.commit(`${this.mmid}/setStoredShopifyCart`, tokenCart, { root: true });

      // Delete from shopify cart
      const resp = await shopifyCart.removeTokenCartItems(
        existingTokenCartItems,
        this.cartIconSection
      );

      // Section updating does not appear to work when the sections contain
      // campaign widget components. The shopify server and liquid code does two
      // odd things:
      // 1. It does not render snippets
      // 2. It strips out custom css for the component
      // As such, we will simply do a reload when items are deleted to force the page to
      // pull the latest data
      if (resp) window.location.reload();
      /*
      let sectionsUpdated = false;
      if (resp && resp.sections && this._cartIconSection) {
        for (const cartIconSection of this._cartIconSection.split(',')) {
          const newCartIconBubble = resp.sections[cartIconSection];
          if (document.getElementById(cartIconSection) && newCartIconBubble) {
            document.getElementById(cartIconSection)!.innerHTML = newCartIconBubble;
            sectionsUpdated = true;
          }
        }
      }

      if (sectionsUpdated) {
        // If sections were updated this may also result in manifold widgets to be re-inserted,
        // so we need to inject them again to be safe
        window.dispatchEvent(new CustomEvent(MANIFOLD_LOAD_REQUEST));
        // Dispatch cart updated event
        window.dispatchEvent(new CustomEvent(CAMPAIGN_CART_UPDATED));
      }
      */
    } catch (e: any) {
      // Error updating cart
      let message: any;
      try {
        const response = await e.json();
        message = response.message;
      } catch {}
      if (message) {
        alert(
          `${message}\nPlease try removing the item again.\nIf you continue having a problem, try clearing your cart.`
        );
      } else {
        console.log(`Unhandled error when removing from cart`, e);
        alert(
          `Problem removing from cart, please try again.\nIf you continue having a problem, try clearing your cart.`
        );
      }
    }
    this.removingFromCart = false;
  }
}
